import { render, staticRenderFns } from "./leijiyishouqu.vue?vue&type=template&id=2b905596&scoped=true&"
import script from "./leijiyishouqu.vue?vue&type=script&lang=js&"
export * from "./leijiyishouqu.vue?vue&type=script&lang=js&"
import style0 from "./leijiyishouqu.vue?vue&type=style&index=0&id=2b905596&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b905596",
  null
  
)

export default component.exports